export default "__VITE_ASSET__CY8M7yQt__"